import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(goal_id, params) {
		return Repository.get(`/company/${company.value.id}/admin/goal/${goal_id}/period`, { params: params });
	},
	store(goal_id, payload) {
		return Repository.post(`/company/${company.value.id}/admin/goal/${goal_id}/period`, payload).then((response) => {
			toast.success(`Período creado correctamente.`);
			return response;
		});
	},
	copy(goal_id, id) {
		return Repository.get(`/company/${company.value.id}/admin/goal/${goal_id}/period/copy`);
	},
	show(goal_id, id) {
		return Repository.get(`/company/${company.value.id}/admin/goal/${goal_id}/period/${id}`);
	},
	update(goal_id, id, payload) {
		return Repository.put(`/company/${company.value.id}/admin/goal/${goal_id}/period/${id}`, payload).then((response) => {
			toast.success(`Período actualizado correctamente.`);
			return response;
		});
	},
	destroy(goal_id, id) {
		return Repository.delete(`/company/${company.value.id}/admin/goal/${goal_id}/period/${id}`).then((response) => {
			toast.success(`Período eliminado correctamente.`);
			return response;
		});
	}
}